import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {alto} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  itemContainer: {
    width: '100%',
    paddingVertical: indent * 1.1,
    paddingHorizontal: indent * 0.9,
    borderTopWidth: 1,
    borderColor: alto,
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    marginRight: indent * 1.15,
    fontSize: 20,
  },
});
